import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  private niceEmailLambda = 'https://5tpbwi6rag6hwg6f6wibh5f6ce0ipumq.lambda-url.us-east-1.on.aws/';
  private googleDocsLambda = "https://ym2i2niuhmpbtitstoxpmj4xie0lfbcf.lambda-url.us-east-1.on.aws/"; 
  private exportedDocs ="https://oqsnausptp4r7s2fd4vihhpvv40jfhxn.lambda-url.us-east-1.on.aws/";
  private emailLamba = "https://3vlkyy5ra4zuekkfiss5ujetoa0tatjo.lambda-url.us-east-1.on.aws/"; 

    constructor(private http: HttpClient) {

    }

    fetchTess(prompt: string, readingLevel: string = '4'): Observable<any> {
      const requestBody = { userprompt: prompt };
      const headers = { 'header1': readingLevel };
  
      return this.http.post<any>(this.emailLamba, requestBody, { headers }).pipe(
        catchError(error => {
          console.error('Error in Reading Level API call:', error);
          return throwError(() => new Error(`API Error: ${error.message || error}`));
        })
      );
    }

  fetchReading(document: File, readingLevel: string = '6'): Observable<any> {
    return new Observable<any>((observer) => {
      if (!document) {
        observer.error('No file selected');
        return;
      }
  
      const reader = new FileReader();
  
      reader.onloadend = () => {
        if (reader.result) {
          try {
            if (document.type === 'application/pdf') {
              const arrayBuffer = reader.result as ArrayBuffer;
              const uint8Array = new Uint8Array(arrayBuffer);
              let binaryString = '';
  
              // Convert each byte to a character
              for (let i = 0; i < uint8Array.length; i++) {
                binaryString += String.fromCharCode(uint8Array[i]);
              }
  
              // Convert to Base64
              const base64String = btoa(binaryString);
  
              console.log('PDF size:', base64String.length);
  
              const headers = { 'header1': readingLevel };
  
              this.http.post<any>(this.googleDocsLambda, base64String, { headers }).pipe(
                catchError(error => {
                  console.error('Error processing PDF:', error);
                  observer.error(error);
                  return throwError(() => error);
                })
              ).subscribe({
                next: (response) => {
                  observer.next(response);
                  observer.complete();
                },
                error: (err) => observer.error(err)
              });
            } else {
              // Handle other document types
            }
          } catch (error) {
            console.error('Error processing file:', error);
            observer.error(error);
          }
        } else {
          observer.error('Could not read file');
        }
      };
  
      reader.onerror = (error) => observer.error(error);
  
      if (document.type === 'application/pdf') {
        reader.readAsArrayBuffer(document);
      } else {
        reader.readAsDataURL(document);
      }
    });
  }
  
  fetchLevelsDoc(document: File, readingLevel: string = '6'): Observable<any> {
    return new Observable<any>((observer) => {
      if (!document) {
        observer.error('No file selected');
        return;
      }
  
      const reader = new FileReader();
  
      reader.onloadend = () => {
        if (reader.result) {
          try {
           
            if (document.type === 'application/pdf') {
              
              const arrayBuffer = reader.result as ArrayBuffer;
              // Convert ArrayBuffer to Uint8Array
              const uint8Array = new Uint8Array(arrayBuffer);
              // Convert Uint8Array to regular array of numbers
              const numberArray = Array.from(uint8Array);
              // Convert array of numbers to string of binary data
              const binaryString = String.fromCharCode.apply(null, numberArray);
              // Convert binary string to base64
              const base64String = btoa(binaryString);
              
              console.log('PDF size:', base64String.length);
              
              // Set headers for the request
              const headers = { 'header1': readingLevel };
              
              // Make the request with the base64 string directly in the body
              this.http.post<any>(this.googleDocsLambda, base64String, { headers }).pipe(
                catchError(error => {
                  console.error('Error processing PDF:', error);
                  observer.error(error);
                  return throwError(() => error);
                })
              ).subscribe({
                next: (response) => {
                  observer.next(response);
                  observer.complete();
                },
                error: (err) => observer.error(err)
              });
            } 
            // Handle other document types
            else {
              // Existing code for other document types...
            }
          } catch (error) {
            console.error('Error processing file:', error);
            observer.error(error);
          }
        } else {
          observer.error('Could not read file');
        }
      };
  
      reader.onerror = (error) => observer.error(error);
  
      // For PDFs, read as array buffer
      if (document.type === 'application/pdf') {
        reader.readAsArrayBuffer(document);
      } else {
        reader.readAsDataURL(document);
      }
    });
  }

  fetchLevel(document: File, readingLevel: string = '10'): Observable<any> {
    return new Observable<any>((observer) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        if (reader.result) {
          const base64Image = reader.result.toString().split(',')[1];

          const requestBody = {
            image: base64Image
          };

          const headers = {
            'header1': readingLevel
          };

          this.http.post<any>(this.niceEmailLambda, requestBody, { headers }).pipe(
            catchError((error) => {
              console.error('Error fetching description:', error);
              observer.error(error);
              return throwError(() => error);
            })
          ).subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
            },
            error: (err) => {
              observer.error(err);
            }
          });
        } else {
          observer.error('Could not read file as base64');
        }
      };

      reader.onerror = (error) => {
        observer.error(error);
      };

      reader.readAsDataURL(document);
    });
  }

  fetchRead(prompt: string, readingLevel: string = '2'): Observable<any> {
    const requestBody = { userprompt: prompt };
    const headers = { 'header1': readingLevel };

    return this.http.post<any>(this.niceEmailLambda, requestBody, { headers }).pipe(
      catchError(error => {
        console.error('Error in Reading Level API call:', error);
        return throwError(() => new Error(`API Error: ${error.message || error}`));
      })
    );
  }
}
